import { AuthRepository } from '../repositories/AuthRepository';
import { LoginRequestDto } from '../dtos/AuthDto';

export class AuthService {
    static async login(credentials: LoginRequestDto) {
        try {
            const response = await AuthRepository.login(credentials);
            if (response.status === 'success' && response.token) {
                localStorage.setItem('admin_token', response.token);
                localStorage.setItem('admin_user', JSON.stringify(response.user));
            }
            return response;
        } catch (error: any) {
            console.error('Login error:', error);
            throw error;
        }
    }

    static async logout() {
        try {
            await AuthRepository.logout();
        } finally {
            localStorage.removeItem('admin_token');
            localStorage.removeItem('admin_user');
        }
    }

    static async getProfile() {
        try {
            const response = await AuthRepository.getProfile();
            if (response.status === 'success' && response.data) {
                localStorage.setItem('admin_user', JSON.stringify(response.data));
            }
            return response.data;
        } catch (error) {
            console.error('Error fetching profile:', error);
            throw error;
        }
    }

    static isAuthenticated(): boolean {
        return !!localStorage.getItem('admin_token');
    }

    static getCurrentUser() {
        const user = localStorage.getItem('admin_user');
        return user ? JSON.parse(user) : null;
    }

    static async updateProfile(data: any) {
        try {
            const formData = new FormData();

            // Basic fields
            formData.append('current_password', data.current_password);
            if (data.name) {
                formData.append('name', data.name);
                formData.append('official_name', data.name);
            }
            if (data.email) formData.append('email', data.email);
            if (data.contact_phone) formData.append('contact_phone', data.contact_phone);

            // Password change
            if (data.new_password) {
                formData.append('new_password', data.new_password);
                formData.append('new_password_confirmation', data.new_password_confirmation);
            }

            // Certificates
            if (data.certificates && data.certificates.length > 0) {
                data.certificates.forEach((file: File) => {
                    formData.append('certificates[]', file);
                });
            }

            if (data.deleted_certificates && data.deleted_certificates.length > 0) {
                data.deleted_certificates.forEach((path: string) => {
                    formData.append('deleted_certificates[]', path);
                });
            }

            const response = await AuthRepository.updateProfile(formData);

            if (response.status === 'success' && response.data) {
                // Update local storage with new data
                localStorage.setItem('admin_user', JSON.stringify(response.data));
            }

            return response;
        } catch (error: any) {
            console.error('Update profile error:', error);
            throw error;
        }
    }
}
